import { TextProps } from "./types";

const Text = ({ children, i, b, n, blockquote, variant, className, onClick = () => null, h1, h2, h3, h4, h5, h6, mNone, type, style }: TextProps) => {
  // mention variants here
  function getVariant(variant: string) {
    switch (variant) {
      case "biggest":
        return " text-[48px] ";
      case "bigger":
        return " text-[36px] ";
      case "big":
        return " text-[30px] ";
      case "large":
        return " text-[28px] ";
      case "xxl":
        return " text-[24px] ";
      case "xl":
        return " text-[22px] ";
      case "lg":
        return " text-[20px] ";
      case "regular":
        return " text-[18px] ";
      case "md":
        return " text-[16px] ";
      case "sm":
        return " text-[14px] ";
      case "xs":
        return " text-[12px] ";
      case "xxs":
        return " text-[11px] ";
      case "smallest":
        return " text-[10px] ";
    }
  }

  // mention types here
  function getType(type: string) {
    switch (type) {
      case "gray-800":
        return " text-gray-800 ";
      case "gradient":
        return " bg-[linear-gradient(to_right,#0072f5_-20%,#0a4281_50%)] [-webkit-text-fill-color:transparent]	bg-clip-text ";
      case "characterTitle":
        return " leading-none tracking-tighter justify-center mt-0.5  ";
      case "error":
        return " text-red-600 ";
      case "warning":
        return " text-warning ";
      case "festive":
        return " text-center text-colorFestive text-[2rem] ";
      case "neutral":
        return " text-gray-600 ";
      case "secondary":
        return " text-secondary ";
      case "primary":
        return " text-primary ";
      case "success":
        return " text-success ";
      case "black":
        return " text-[#000000]  ";
      case "!black":
        return " !text-[#000000]  ";
      case "white":
        return " !text-[#FFF] ";
      case "pink-1000":
        return " !text-[#ff4081] ";
      case "colorFestive":
        return " text-[#b7318e] ";
      case "normal":
        return " font-normal ";
      case "medium":
        return " font-medium ";
      case "fix_required":
        return " !text-colorFixRequired ";
      case "under_review":
        return " !text-colorUnderReview ";
      case "steel_blue":
        return " !text-colorSteelBlue ";
      case "blue":
        return " !text-blue-600 ";
      case "neutral_text":
        return " !text-neutral-text ";
      case "neutral_secondary":
        return " !text-neutral-secondary ";
      case "chatDisclaimer":
        return " !text-chatDisclaimer leading-4 text-center font-normal ";
      case "errorSectionDisclaimer":
        return " !text-neutralPrimary leading-5 text-center ";
      default:
        return type;
    }
  }

  // used to calculate multiple types
  function getCombinedTypes(type: string) {
    if (type?.split(" ")?.length > 1) {
      const arr = type
        ?.split(" ")
        .map((text) => getType(text))
        .join(" ");
      return " " + arr + " ";
    } else {
      return " " + getType(type) + " ";
    }
  }

  const spicyStyles =
    `text-foreground ${i && "italic"} ${b && "font-bold"} ${n && "!font-normal"} ${mNone && "m-0"} ` +
    className +
    " " +
    getVariant(variant ?? "") +
    " " +
    getCombinedTypes(type ?? "");

  if (h1) {
    return (
      <h1 className={spicyStyles} onClick={onClick} style={{ ...style }}>
        {children}
      </h1>
    );
  }

  if (h2) {
    return (
      <h2 className={spicyStyles} onClick={onClick} style={{ ...style }}>
        {children}
      </h2>
    );
  }

  if (h3) {
    return (
      <h3 className={spicyStyles} onClick={onClick} style={{ ...style }}>
        {children}
      </h3>
    );
  }

  if (h4) {
    return (
      <h4 className={spicyStyles} onClick={onClick} style={{ ...style }}>
        {children}
      </h4>
    );
  }

  if (h5) {
    return (
      <h5 className={spicyStyles} onClick={onClick} style={{ ...style }}>
        {children}
      </h5>
    );
  }

  if (h6) {
    return (
      <h6 className={spicyStyles} onClick={onClick} style={{ ...style }}>
        {children}
      </h6>
    );
  }

  return (
    <span className={spicyStyles} onClick={onClick} style={{ ...style }}>
      {blockquote ? (
        <blockquote className="mb-5 mt-3 py-4 px-5 w-full bg-gray-50 rounded-[4px] [overflow-wrap:anywhere]">{children}</blockquote>
      ) : (
        children
      )}
    </span>
  );
};

export default Text;
